import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_orders_attachments_hub_ComponentContextService } from './FootprintManager.orders_attachments_hub.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { FootprintManager_entity_attachments_gridComponent } from './FootprintManager.entity_attachments_grid.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_entity_attachments_gridComponent),
  ],
  selector: 'FootprintManager-orders_attachments_hub',
  templateUrl: './FootprintManager.orders_attachments_hub.component.html'
})
export class FootprintManager_orders_attachments_hubComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { orderId?: number, shipmentId?: number } = { orderId: null, shipmentId: null };
  //#region Inputs
  @Input('orderId') set $inParams_orderId(v: number) {
    this.inParams.orderId = v;
  }
  get $inParams_orderId(): number {
    return this.inParams.orderId;
  }
  @Input('shipmentId') set $inParams_shipmentId(v: number) {
    this.inParams.shipmentId = v;
  }
  get $inParams_shipmentId(): number {
    return this.inParams.shipmentId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
  };


  filtersets = {
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      order_attachments: new TabItemModel(
        this.rootTabGroup, 
        'Order attachments', 
        false,
        ),
      shipment_attachments: new TabItemModel(
        this.rootTabGroup, 
        'Shipment attachments', 
        false,
        ),
    };
  
  
    //#region tabs inParams
    get $tabs_order_attachments_entity_attachments_grid_inParams_entityType(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = 'Order';
      
      return expr;
    }
  
    cacheValueFor_$tabs_order_attachments_entity_attachments_grid_inParams_entityKeys: { name?: string, value?: any }[];
    get $tabs_order_attachments_entity_attachments_grid_inParams_entityKeys(): { name?: string, value?: any }[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = [{ name: 'Id', value: $hub.inParams.orderId }];
      
      if(!isEqual(this.cacheValueFor_$tabs_order_attachments_entity_attachments_grid_inParams_entityKeys, expr)) {
        this.cacheValueFor_$tabs_order_attachments_entity_attachments_grid_inParams_entityKeys = expr;
      }
      return this.cacheValueFor_$tabs_order_attachments_entity_attachments_grid_inParams_entityKeys;
    }
  
    get $tabs_shipment_attachments_entity_attachments_grid_inParams_entityType(): string {
      const $hub = this;
      const $utils = this.$utils;
      const expr = 'Shipment';
      
      return expr;
    }
  
    cacheValueFor_$tabs_shipment_attachments_entity_attachments_grid_inParams_entityKeys: { name?: string, value?: any }[];
    get $tabs_shipment_attachments_entity_attachments_grid_inParams_entityKeys(): { name?: string, value?: any }[] {
      const $hub = this;
      const $utils = this.$utils;
      const expr = [{ name: 'Id', value: $hub.inParams.shipmentId }];
      
      if(!isEqual(this.cacheValueFor_$tabs_shipment_attachments_entity_attachments_grid_inParams_entityKeys, expr)) {
        this.cacheValueFor_$tabs_shipment_attachments_entity_attachments_grid_inParams_entityKeys = expr;
      }
      return this.cacheValueFor_$tabs_shipment_attachments_entity_attachments_grid_inParams_entityKeys;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_order_attachments', { read: FootprintManager_entity_attachments_gridComponent }) $tabs_order_attachments: FootprintManager_entity_attachments_gridComponent;
      @ViewChild('$tabs_shipment_attachments', { read: FootprintManager_entity_attachments_gridComponent }) $tabs_shipment_attachments: FootprintManager_entity_attachments_gridComponent;
    //#endregion tabs children


  get hubTitle(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Attachments`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.$utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `View order and shipment attachments below`;
  }

  constructor(
  private $utils: UtilsService,
  private $settings: SettingsValuesService,
  private $shell: FootprintManager_ShellService,
  private $datasources: FootprintManager_DatasourceService,
  private $flows: FootprintManager_FlowService,
  private $reports: FootprintManager_ReportService,
  private $localization: FootprintManager_LocalizationService,
  private $operations: FootprintManager_OperationService,
  private $logger: CleanupLoggerService,
  private $context: FootprintManager_orders_attachments_hub_ComponentContextService,
  ) { 
    super();
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.order_attachments,
      this.tabs.shipment_attachments,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'orders_attachments_hub';
    
    const $hub = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_order_attachments') {
      if (!isNil(this.$tabs_order_attachments) && !this.tabs.order_attachments.hidden) {
        this.$tabs_order_attachments.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_shipment_attachments') {
      if (!isNil(this.$tabs_shipment_attachments) && !this.tabs.shipment_attachments.hidden) {
        this.$tabs_shipment_attachments.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootprintManager_orders_attachments_hubComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_orders_attachments_hub_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $hub.title = 'Attachments'
  }
  //#endregion private flows
}
